(function () {
  if (window.__dbCollSort) return;
  window.__dbCollSort = true;

  function sortValue() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('sort_by')) return params.get('sort_by');
    var sel = document.querySelector('select[name="sort_by"]');
    return sel ? sel.value : '';
  }

  function reorder() {
    if (window.location.pathname.indexOf('/collections/') === -1) return;
    if (sortValue() !== 'best-selling') return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var items = [];
    for (var i = 0; i < grid.children.length; i++) {
      if (grid.children[i].nodeType === 1) items.push(grid.children[i]);
    }
    if (items.length < 2) return;

    var best = [], rest = [];
    for (var j = 0; j < items.length; j++) {
      if (items[j].querySelector && items[j].querySelector('.db-bs-badge')) best.push(items[j]);
      else rest.push(items[j]);
    }
    if (!best.length || !rest.length) return;

    // Already grouped (all bestsellers precede the rest) -> nothing to do.
    if (items.indexOf(best[best.length - 1]) < items.indexOf(rest[0])) return;

    var frag = document.createDocumentFragment();
    for (var b = 0; b < best.length; b++) frag.appendChild(best[b]);
    for (var r = 0; r < rest.length; r++) frag.appendChild(rest[r]);
    grid.appendChild(frag);
  }

  function init() {
    reorder();
    var container = document.getElementById('ProductGridContainer');
    if (container && window.MutationObserver) {
      // Shopify swaps the container's inner content on AJAX sort/filter; re-apply then.
      // childList only (not subtree) so our own <li> reshuffle never re-triggers this.
      new MutationObserver(function () { reorder(); }).observe(container, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
